// extracted by mini-css-extract-plugin
export default {"FlexContainer":"FlexContainer-module__FlexContainer__JxOgr","FlexContainerColumn":"FlexContainer-module__FlexContainerColumn__sd4aY"};